module.exports = __webpack_public_path__ + "img/house-1@3x.9eeab388.jpg";